var render = function render(){var _vm=this,_c=_vm._self._c;return _c('extra-table',{attrs:{"title":_vm.$t('companies'),"entity":"companies","fields":_vm.fields,"search":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }